import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import InfoIcon from "@mui/icons-material/Info";
import Cisinformation from "../Cisinformation/Cisinformation";
import {
  Card,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Chip,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import ReadMoreAndLess from "react-read-more-less";
import GroupFormdata from "../Userdata/Groupform1";
import OverallSelectedFormdata from "../Userdata/OverallSelectedform1";

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    numSelected,
    rowCount,
    inputProps,
    value,
    key,
    name,
    HeaderNameUD,
  } = props;
  return (
    <>
      <TableHead className="bg-lightBlue-200">
        <TableRow className="align-items-center table-flush css-serial">
          {window.localStorage.getItem("rollback_run_access") ===
          "You do not have permission to perform this action." ? (
            ""
          ) : (
            <React.Fragment>
              <TableCell width="5%" padding="checkbox"></TableCell>
            </React.Fragment>
          )}
          <TableCell width="5%" align="center">
            <h6>Cis_no</h6>
          </TableCell>
          <TableCell align="center">
            <h6>CIS_Topic</h6>
          </TableCell>
          <TableCell align="center">
            <h6>More_Info</h6>
          </TableCell>
        </TableRow>
      </TableHead>
    </>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const EnhancedTableToolbar = (props) => {
  const { failedcount, customcolor, content, overallcount } = props;
  return (
    <React.Fragment>
      <a>
        <span style={{ color: customcolor }}>
          {/* {content} Audits : {failedcount} / Overall Audits : {overallcount} */}
        </span>
      </a>
    </React.Fragment>
  );
};

EnhancedTableToolbar.propTypes = {
  Overallcount: PropTypes.number.isRequired,
  Failedcount: PropTypes.number.isRequired,
  numSelected: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function AuditTable(props) {
  const {
    CisResults,
    overallAudit,
    failedAudit,
    hostprimarykey,
    userdatatags,
    backup,
  } = props;

  window.sessionStorage.setItem("CisResults", CisResults);
  const [newresult, setNewresult] = React.useState([]);
  const [headerUD, setHeaderUD] = useState([]);

  const [selected, setSelected] = React.useState([]);

  const [itemselected, setItemselected] = React.useState([]);

  const [selectalltagsstatus, setSelectalltagsstatus] = React.useState(false);
  const [selectUserdatacisno, setSelectUserdatacisno] = React.useState([]);

  const [childrenselected, setChildrenselected] = React.useState([]);

  useEffect(() => {
    setNewresult({ CisResults });
    if (CisResults) {
      CisResults.map((val) => {
        if (val.header_userData === "yes") {
          setHeaderUD((prevState) => ({
            ...prevState,
            [val.header_id]: "yes",
          }));
        }
        val.result.map((row) => {
          setdropdown((prevState) => ({ ...prevState, [row.cis_no]: false }));
        });
      });
    }
  }, [CisResults]);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const totalselected = CisResults.map((row) => {
        const seperateResult = row.result.map((value) => {
          const cis_number = value.cis_no;
          return cis_number;
        });
        return seperateResult;
      });
      const data = JSON.stringify(totalselected);
      const jsonstrinifydata = data
        .replace(/\[/g, "")
        .replace(/\]/g, "")
        .replace(/[,]+/g, ","); //replace(/,,/g, ',')
      const changeValue = "[" + jsonstrinifydata + "]";
      const jsonparsefield = JSON.parse(changeValue);
      const filtered = jsonparsefield.filter(function (el) {
        return el != null;
      });

      setSelected(filtered);
      setItemselected(filtered);
      setSelectalltagsstatus(true);
      return null;
    }
    setSelected([]);
    setSelectalltagsstatus(false);
    return null;
  };

  const handleClick = (event, cis_no) => {
    const selectedIndex = selected.indexOf(cis_no);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, cis_no);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    const totalselected = CisResults.map((row) => {
      const seperateResult = row.result.map((value) => {
        const cis_number = value.cis_no;
        return cis_number;
      });
      return seperateResult;
    });

    const data = JSON.stringify(totalselected);
    const jsonstrinifydata = data
      .replace(/\[/g, "")
      .replace(/\]/g, "")
      .replace(/[,]+/g, ",");
    const changeValue = "[" + jsonstrinifydata + "]";
    const jsonparsefield = JSON.parse(changeValue);
    const filtered = jsonparsefield.filter(function (el) {
      return el != null;
    });
    setSelected(newSelected);
    setItemselected(filtered);
  };
  const selectedtags = selected;

  const [notcheck, setNotcheck] = useState(false);
  const [focusAfterClosecheck] = useState(true);
  const notchecktoggle = () => setNotcheck(!notcheck);
  const [headercheck, setHeadercheck] = React.useState([]);
  const [datacheck, setdatacheck] = React.useState([]);
  const [assignuserdata, setAssignuserdata] = React.useState([]);
  const [newstate, setNewstate] = React.useState([]);

  const IndualSubmit = (selected) => {
    var value1 = JSON.stringify(newstate);
    var backupdata;
    let sub = {
      temp_id: window.sessionStorage.getItem("tempID").toString(),
      taglist: selected.toString(),
    };
    return function () {
      const temp_id = window.sessionStorage.getItem("TempID");
      fetch(`${process.env.REACT_APP_API_URL}/api/run_temp/${temp_id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
        body: JSON.stringify(sub),
      })
        .then((response) => response.json())
        .then((data) => {
          window.localStorage.setItem("remedy_run_limit", data.detail);
          window.sessionStorage.setItem("access_userdata", "notchecked");
          window.sessionStorage.removeItem("userdata");
          window.location.href = "/admin/remedy";
        })
        .catch((error) => {
          console.log(error);
          window.location.reload();
          window.sessionStorage.setItem("access_userdata", "notchecked");
          window.sessionStorage.removeItem("userdata");
        });
    };
  };

  const isSelected = (cis_no) => selected.indexOf(cis_no) !== -1;

  const isChildrenselected = (cis_no) =>
    childrenselected.indexOf(cis_no) !== -1;

  const [open, setOpen] = useState(false);
  const [focusAfterClose] = useState(true);
  const toggle = () => setOpen(!open);

  const [expandedheader, setExpandedheader] = React.useState({});

  const handleChangedropdown = (panel) => (event, isExpanded) => {
    setExpandedheader(isExpanded ? panel : false);
  };

  const filterHandle = () => {
    setExpandedheader({ expandedheader: true });
  };

  const [dropdown, setdropdown] = React.useState([]);
  const checkmoreinfo = (cis_no) => (e) => {
    e.preventDefault();
    var value;
    if (dropdown[cis_no]) {
      value = false;
    } else {
      value = true;
    }
    setdropdown((prevState) => ({ ...prevState, [cis_no]: value }));
  };

  return (
    <React.Fragment>
      <Card>
        <CardHeader
          action={
            <React.Fragment>
              <OverallSelectedFormdata
                headerUD={headerUD}
                selectedtags={selectedtags}
                selectalltagsstatus={selectalltagsstatus}
                selectUserdatacisno={selectUserdatacisno}
                setAssignuserdata={setAssignuserdata}
                assignuserdata={assignuserdata}
                backup={backup}
              />
            </React.Fragment>
          }
          title={window.sessionStorage.getItem("platform")}
        />

        <div className="mr-2 px-4 py-2">
          <Chip
            icon={
              <React.Fragment>
                <Checkbox
                  indeterminate={
                    selected.length > 0 && selected.length < itemselected.length
                  }
                  checked={
                    itemselected.length > 0 &&
                    selected.length === itemselected.length
                  }
                  onChange={handleSelectAllClick}
                  inputProps={{ "aria-label": "select all desserts" }}
                  title="select all"
                />
              </React.Fragment>
            }
            label={
              <Typography fontWeight="fontWeightBold" variant="h7">
                <strong>Select all</strong>
              </Typography>
            }
            variant="outlined"
          />
        </div>
        {newresult.CisResults ? (
          <React.Fragment>
            {CisResults.map((val, index) => {
              const isItemSelected = isSelected(val.header_id);
              const labelId = `select all desserts-${index}`;
              const tags = val.tags;
              if (tags.length > 0) {
                return (
                  <React.Fragment>
                    <Accordion
                      defaultExpanded={expandedheader ? true : false}
                      onChange={handleChangedropdown(val.header_id)}
                      style={{ cursor: "pointer" }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography fontWeight="fontWeightBold" variant="h7">
                          <strong>{val.header_id}</strong> - {val.header_name}
                        </Typography>
                      </AccordionSummary>
                      {val.header_userData === "yes" ? (
                        <AccordionDetails
                          style={{ justifyContent: "space-between" }}
                        >
                          <GroupFormdata
                            header_id={val.header_id}
                            header_name={val.header_name}
                            tags={val.tags}
                            setdatacheck={setdatacheck}
                            setAssignuserdata={setAssignuserdata}
                            assignuserdata={assignuserdata}
                            selected={selected}
                            itemselected={itemselected}
                            setSelected={setSelected}
                            backup={backup}
                          />
                        </AccordionDetails>
                      ) : (
                        ""
                      )}
                      <AccordionDetails>
                        <TableContainer
                          component={Paper}
                          style={{ borderColor: "#333" }}
                        >
                          <Table
                            aria-labelledby="tableTitle"
                            aria-label="enhanced table"
                            bordered
                          >
                            <EnhancedTableHead
                              value={val.result}
                              name={val.header_id}
                              numSelected={selected.length}
                              onSelectAllClick={handleSelectAllClick}
                              rowCount={itemselected.length}
                              inputProps={{ "aria-label": labelId }}
                              key={index}
                              HeaderNameUD={val.header_userData}
                            />
                            <TableBody>
                              {val.result.map((row, sindex) => {
                                const isItemSelected = isSelected(row.cis_no);
                                const labelId = `enhanced-table-checkbox-${sindex}`;

                                return (
                                  <React.Fragment>
                                    <TableRow>
                                      {window.localStorage.getItem(
                                        "rollback_run_access"
                                      ) ===
                                      "You do not have permission to perform this action." ? (
                                        ""
                                      ) : (
                                        <TableCell
                                          width="15%"
                                          padding="checkbox"
                                        >
                                          <Checkbox
                                            hover
                                            disabled={
                                              val.header_userData === "yes"
                                                ? true
                                                : false
                                            }
                                            onClick={(event) =>
                                              handleClick(event, row.cis_no)
                                            }
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            selected={isItemSelected}
                                            checked={isItemSelected}
                                            inputProps={{
                                              "aria-labelledby": labelId,
                                            }}
                                          />
                                        </TableCell>
                                      )}
                                      <TableCell
                                        align="center"
                                        component="th"
                                        id={labelId}
                                        scope="row"
                                        padding="none"
                                        width="15%"
                                      >
                                        {row.cis_no}
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          textAlign: "left",
                                          whiteSpace: "normal",
                                          wordWrap: "break-word",
                                        }}
                                      >
                                        <ReadMoreAndLess
                                          className="read-more-content"
                                          charLimit={100}
                                          readMoreText="Read more"
                                          readLessText="Read less"
                                        >
                                          {row.cis_topic_name}
                                        </ReadMoreAndLess>
                                      </TableCell>
                                      <TableCell width="5%" align="center">
                                        <IconButton
                                          color="primary"
                                          size="sm"
                                          title="Info"
                                          style={{
                                            padding: "0px",
                                          }}
                                          onClick={checkmoreinfo(row.cis_no)}
                                        >
                                          <KeyboardArrowDownIcon fontSize="small" />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                    {dropdown[row.cis_no] ? (
                                      <TableRow
                                        id={"multiCollapse" + row.cis_no}
                                      >
                                        <Cisinformation
                                          OS={window.sessionStorage.getItem(
                                            "platform"
                                          )}
                                          FactName={row.fact_name}
                                        />
                                      </TableRow>
                                    ) : (
                                      ""
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </AccordionDetails>
                    </Accordion>
                  </React.Fragment>
                );
              }
            })}
          </React.Fragment>
        ) : (
          ""
        )}
        <br />
        <br />
      </Card>
    </React.Fragment>
  );
}

export default AuditTable;